"use client"; import React from "react"; export function KnowledgeManagementClient() { return <div className="p-6"><h2 className="text-xl font-bold">지식 관리</h2><p className="text-gray-600">API 기반 지식 관리 시스템</p></div>; }
